<template>
  <div class="home">
     <App-navigation></App-navigation>
     <v-container grid-list-lg>

        <v-layout row>
            <v-flex  class="text-xs-center display-1 font-weight-black ">
               Welcome {{ staff.gender == 'male' ? 'Mr.' : 'Miss.' }} {{staff.fullname.toUpperCase()}} 
                           </v-flex>
            <v-text-field
              v-model="search"
              prepend-icon="search"
              append-icon="mic"
              label="Search"
              solo-inverted
              class="mx-2"
              flat

            ></v-text-field>

            
        </v-layout>
        <v-layout row wrap>
            <v-flex class="text-xs-center display-3 font-weight-black my-3" >
              <v-data-table :headers="headers" :items="loads()" :search="search" :custom-filter="customFilter" hide-actions class="elevation-1">
                <template slot="items" slot-scope="{item}">
                  <td><b>{{item.sn}}</b></td>
                  <td class="text-xs-center">{{item.name.toUpperCase()}}</td>
                  <td class="text-xs-center">{{item.email}}</td>
                  <td class="text-xs-center">{{item.phone_no}}</td>
                  <td class="text-xs-center">{{item.gender.toUpperCase()}}</td>
                  <td class="text-xs-center">{{item.rights}}</td>
                  <td class="justify-center layout px-0">
                   <Edit-staff  v-if="staff.name == item.name" :username="item.name" :name="item.fullname" :email="item.email" :phone="item.phone_no" :campus="item.campus" :gender="item.gender" :rights="item.rights"></Edit-staff>
                   <Edit-staff v-else-if="crc(staff.rights,'013')" :username="item.name" :name="item.fullname" :email="item.email" :phone="item.phone_no" :campus="item.campus" :gender="item.gender" :rights="item.rights"></Edit-staff>
                   <Delete-staff :name="item.name" v-if="crc(staff.rights,'014')"></Delete-staff>
                  </td>
                </template>
              </v-data-table>

            </v-flex>
        </v-layout>
     </v-container>
     
     <Add-staff v-if="crc(staff.rights,'012')"></Add-staff>
  </div>
</template>

<script>
// @ is an alias to /src
import AppNavigation from '@/components/Navigation/AppNavigation.vue'
import AddStaff from '@/components/Staff/AddStaff.vue'
import EditStaff from '@/components/Staff/EditStaff.vue'
import DeleteStaff from '@/components/Staff/DeleteStaff.vue'

import {checkright} from '@/validator'
export default {
  name: 'staff',
  data(){
      return {
          //staff:{fullname:'Okoedo',gender:''},
          staff:this.$store.getters.getStaff, 
          dialog:false,
          search:'',
          headers:[
            { 
              text:'S/N',
              align:'center',
              sortable:true,
              value:'sn'
            },
            {
              text:'USERNAME',
              align:'center',
              sortable:true,
              value:'name'
            },
            {
              text:'EMAIL',
              align:'center',
              sortable:true,
              value:'email'
            },
            {
              text:'PHONE',
              align:'center',
              sortable:true,
              value:'phone'
            },
            {
              text:'GENDER',
              align:'center',
              sortable:true,
              value:'gender'
            },
            {
              text:'RIGHTS',
              align:'center',
              sortable:false,
              value:'rights'
            },
            {
              text:'ACTION',
              sortable:false,
              value:''
            }
          ],
          editedIndex:-1,
          editedItem:{
              name:''
          },
          defaultItem:{
              
          },
          listPrimitive:null
      }
  },
  methods:{
         loads(){
           
            let self=this;
            let value;
            self.$store.dispatch('updateStaffs');
            value = self.$store.getters.getAllStaffs;
            return value;
           
            
        },
    crc(array,value){
      return checkright(array,value);
    },
    customFilter(items,search){

     if(!search){ return items }
     function new_filter(val,search){
       return val !== null &&
        ['undefined','boolean'].indexOf(typeof val) === -1 &&
        val.toString().toLowerCase().replace( /[^0-9a-zA-Z]+/g ,'').indexOf(search) !== -1
     }

     let needleAry = search.toString().toLowerCase().split(" ").filter(x => x);

     return items.filter(row => needleAry.every(needle => Object.keys(row).some(key => new_filter(row[key],needle))));
    }
  },
  components: {
    AppNavigation,
    AddStaff,
    EditStaff,
    DeleteStaff
  }
}
</script>
